<template>
   <div :class="[ hover ? 'hover' : null, clamp ? 'clamp' : null, 'card' ]" 
      :style="`--clamp: ${this.clamp}`">
      <div v-if="image" class="card__image">
         <img :src="image" :alt="image_alt"/>
      </div>
      <div class="card__details">
         <h4>
            <slot name='title'></slot>
         </h4>
         <div class="card__body">
            <slot name='body'></slot>
         </div>
         <a v-if="link" class="card__link" :href="link">{{link_text}}</a>
      </div>
   </div>
</template>

<script>
/**
 * @props
 * image - Source of image to be used as heaedr image
 * image_alt - Image alternate text
 * link - Simple link to link the card to a page
 * link_text - Text for the link
 * hover - Adds a simple hover effect to the card
 * clamp - Clamps line to the number set
 */
  export default {
    props: {
        image: {type: String, default: null},
        image_alt: {type: String, default: null},
        link: {type: String, default: null},
        link_text: { type: String, default: 'Find out more' },
        hover: {type: Boolean, default: false},
        clamp: { type: Number, default: null }
    }
  }

</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/card.scss';
</style>